import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import MessageBanner from './MessageBanner';

const MessageBannerContainer = ({stateKey, usePadding}) => {

    //Fetches nested object by object in state
    const getNestedState = (state, path) => {
        return path.split('.').reduce((acc, key) => acc && acc[key], state);
      };

    const messageBanners = useSelector((state) => getNestedState(state, stateKey));
    return (
        <Fragment>
            {messageBanners && messageBanners.banners.length > 0 && (
                <div className={usePadding ? 'message-banner' : ''}>
                    {messageBanners?.banners.map((banner, index) => (
                        <MessageBanner key={`messageBanner-${index}`} banner={banner} />
                    ))}
                </div>
            )}
        </Fragment>
    );
}

export default MessageBannerContainer;
